import React from 'react';
import * as S from './LoadingButton.style';
import { If } from 'helpers';

export const LoadingButton = React.forwardRef(
    (
        {
            children,
            isLoading,
            loadingText,
            showLoadingText,
            forceClick,
            onClick,
            button,
            disabled,
            ...props
        },
        forwardedRef
    ) => {
        const Button = button;
        return (
            <>
                <Button
                    {...props}
                    disabled={disabled}
                    ref={forwardedRef}
                    onClick={
                        !disabled && (!isLoading || forceClick)
                            ? onClick
                            : () => {}
                    }
                >
                    <If condition={isLoading}>
                        <S.Wrapper>
                            <S.Spinner />
                            <If condition={showLoadingText === true}>
                                <S.Text>{loadingText}</S.Text>
                            </If>
                        </S.Wrapper>
                    </If>
                    <If condition={!isLoading}>{children}</If>
                </Button>
            </>
        );
    }
);
